import React, { Component } from 'react';
import { FaGithub, FaTwitter, FaEnvelope, FaLinkedin } from "react-icons/fa";

import cat from "../img/loki.JPG";
import cupcake from "../img/cupcakes.jpg";
import hiking from "../img/hiking.jpg";
import rock from "../img/rocks.jpg";

import '../styles/about.scss';


class About extends Component {
  render() {
    return (
      <div className="about">
        <section id="about-container">
          <div id="about"></div>
          <div className="section-container">
            <h1 className="title">About</h1>
              <p>I specialize in developing and designing innovative, user-friendly websites and visualizations.  Previously, I've been an interactive developer at LGND, creating immersive websites, interactive 3d graphics, VR / AR experiences, charts, maps, tools, and games. I also worked at the Los Angeles Times, where I used design and code to tell stories, created and documented style guides, and trained others. I love helping others learn to code and teach introductory courses part-time at University of Southern California.</p>

              <p>
              Outside of work, catch me:
                <span className="item">
                  Walking my cats
                  <div className="crop">
                    <div className="bg" style={{backgroundImage:`url(${cat})`}}></div>
                  </div>
                </span>
                <span className="item">
                  Hiking
                  <div className="crop">
                    <div className="bg" style={{backgroundImage:`url(${hiking})`}}></div>
                  </div>
                </span>
                <span className="item">
                  Looking for cool rocks
                    <div className="crop">
                      <div className="bg" style={{backgroundImage:`url(${rock})`}}></div>
                    </div>
                </span>
                <span className="item">
                  Baking
                  <div className="crop">
                    <div className="bg" style={{backgroundImage:`url(${cupcake})`}}></div>
                  </div>
                </span>
              </p>

            <div className="contact" id="contact-container">
              <div id="contact"></div>
                <p><a className="base-link link" href="mailto:andyroberson2@gmail.com">Get in touch</a> or learn more about me
                  <span className="finger">
                    <img src={`${process.env.PUBLIC_URL}/img/finger-point-down.png`} alt="finger pointing" />
                  </span>
              </p>
            </div>

            <div className="icons">
              <a href="mailto:andyroberson2@gmail.com">
                <span className="icon-group">
                    <FaEnvelope />
                    <span>email</span>
                </span>
              </a>
              <a href="https://github.com/andyroberson">
                <span className="icon-group">
                  <FaGithub />
                    <span>github</span>
                </span>
              </a>
              <a href="https://twitter.com/andyroberson22">
                <span className="icon-group">
                    <FaTwitter />
                    <span>twitter</span>
                </span>
              </a>
              <a href="https://www.linkedin.com/in/andrea-roberson/">
                <span className="icon-group">
                    <FaLinkedin />
                    <span>linkedin</span>
                </span>
              </a>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default About;
